import { useMerchantUrlUtils } from './useMerchantUrlUtils';
import type { RouteLocationNormalized } from '#vue-router';

type HasMerchantSlug<T extends RouteLocationNormalized> =
	T extends { params: { merchantSlug: string } } ? string : string | undefined;

export const useMerchantSlug = <T extends RouteLocationNormalized>(route: MaybeRef<T>, useStaticSlug?: boolean) => {
	const { getMerchantSlugByUrl, hasMerchantStaticUrl } = useMerchantUrlUtils();

	const url = useRequestURL();

	const _route = toRef(route);

	const originalMerchantSlug = computed(() => {
		if (!('merchantSlug' in _route.value.params)) {
			return undefined;
		}

		const merchantSlugFromUrl = getMerchantSlugByUrl(url.href);

		if (merchantSlugFromUrl) {
			return merchantSlugFromUrl;
		}

		return String(_route.value.params.merchantSlug);
	}) as ComputedRef<HasMerchantSlug<T>>;

	const merchantSlug = computed(() => {
		if (useStaticSlug && originalMerchantSlug.value && hasMerchantStaticUrl(originalMerchantSlug.value)) {
			return 'c';
		}

		return originalMerchantSlug.value;
	});

	return merchantSlug;
};
